import i18next from 'i18next'

export class ApiError {
  error: string

  constructor(error: string) {
    this.error = error
  }

  errorMessage() {
    if (i18next.exists(`Error.API.${this.error}`)) {
      return i18next.t(`Error.API.${this.error}`)
    }

    return i18next.t('global.error')
  }
}

export const generateApiError = (e: any): ApiError => {
  return new ApiError((e && e.response && e.response.data && e.response.data.Error) || i18next.t('global.form_errors_found'))
}
